import axios from 'axios';
import { SuccessResponse, FailureResponse } from '../client/generic-client-response';
import AffiliateHubLogger from '../util/affiliate-hub-logger';
import { PzOauthErrorCodes } from 'sources/server-error-codes';
import { Logger } from 'bernie-logger';

const GRANT_TYPE = 'authorization_code';

export class PzOAuthSource {
  private logger: AffiliateHubLogger;

  public constructor(logger: Logger) {
    this.logger = new AffiliateHubLogger(logger);
  }

  public async getAccessToken(authorizationCode: string) {
    try {
      const response = await axios.post('/api/v1/pz/oauth/access_token', {
        code: authorizationCode,
        grantType: GRANT_TYPE,
      });

      if (response.data.success) {
        return Promise.resolve(new SuccessResponse(response.data.body.access_token));
      }

      return Promise.reject(response.data);
    } catch (ex) {
      this.logger.error('FAILED_TO_FETCH_ACCESS_TOKEN', ex);
      // this condition makes sure that response received has been handled and massaged properly on the BFF.
      // Else its something unexpected.
      if (ex.response?.data?.success !== undefined) {
        return Promise.reject(ex.response.data);
      }

      return Promise.reject(new FailureResponse(PzOauthErrorCodes.UNKNOWN, ex.response));
    }
  }
}
